import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginModal from './LoginModal';
import landingLogo from '../assets/logo.png';
import '../App.css'; // Global styles for .navbar

const SharedNavbar = ({ activePage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleNavClick = (target) => {
        setIsMobileMenuOpen(false);
        if (location.pathname === '/') {
            const element = document.getElementById(target);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate('/', { state: { target } });
        }
    };

    return (
        <nav className="navbar">
            <div className="nav-content">
                <a onClick={() => handleNavClick("home")} className="logo-brand" style={{ cursor: 'pointer' }}>
                    <img src={landingLogo} alt="Moonshot Logo" className="nav-logo-img" />
                    <span className="logo-text" style={{ color: "#000000" }}>MoonShotMap</span>
                </a>

                {/* DESKTOP NAV (Hidden on mobile via CSS) */}
                <div className="nav-links-container">
                    <button onClick={() => handleNavClick("engine")} className="nav-link">Engine</button>
                    <button onClick={() => navigate("/blog")} className={`nav-link ${ activePage === 'blog' ? 'active' : '' }`}>Blog</button>
                    <button onClick={() => navigate("/pricing")} className={`nav-link ${ activePage === 'pricing' ? 'active' : '' }`}>Pricing</button>
                    <button onClick={() => handleNavClick("how-to")} className={`nav-link ${ activePage === 'how-to' ? 'active' : '' }`}>How to Use</button>
                    <button onClick={() => handleNavClick("who-for")} className="nav-link">Who It’s For</button>
                    <button onClick={() => handleNavClick("contact")} className="nav-link">Contact</button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <button
                        className="login-btn"
                        onClick={() => setShowLoginModal(true)}
                    >
                        <span>Log In</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '16px', height: '16px' }}>
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>

                {/* MOBILE HAMBURGER BUTTON */}
                <button
                    className="mobile-menu-btn"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {isMobileMenuOpen ? (
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    ) : (
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    )}
                </button>
            </div>

            {/* MOBILE MENU OVERLAY */}
            <div className={`mobile-nav-overlay ${ isMobileMenuOpen ? "open" : "" }`} style={{ background: '#fff' }}>
                <button onClick={() => handleNavClick("engine")} className="mobile-nav-link" style={{ color: '#000' }}>Engine</button>
                <button onClick={() => navigate("/blog")} className={`mobile-nav-link ${ activePage === 'blog' ? 'active' : '' }`} style={{ color: '#000' }}>Blog</button>
                <button onClick={() => navigate("/pricing")} className={`mobile-nav-link ${ activePage === 'pricing' ? 'active' : '' }`} style={{ color: '#000' }}>Pricing</button>
                <button onClick={() => handleNavClick("how-to")} className={`mobile-nav-link ${ activePage === 'how-to' ? 'active' : '' }`} style={{ color: '#000' }}>How to Use</button>
                <button onClick={() => handleNavClick("who-for")} className="mobile-nav-link" style={{ color: '#000' }}>Who It’s For</button>
                <button onClick={() => handleNavClick("contact")} className="mobile-nav-link" style={{ color: '#000' }}>Contact</button>

                <button
                    className="cta-primary"
                    onClick={() => {
                        setIsMobileMenuOpen(false);
                        setShowLoginModal(true);
                    }}
                    style={{ marginTop: "1rem", width: "200px" }}
                >
                    Log In
                </button>
            </div>

            <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
        </nav>
    );
};

export default SharedNavbar;
